<div class="container p-4">
  <h2 class="mb-4">Agregar operación al Gestor de Proyectos</h2>

  <form [formGroup]="formCuotas" (ngSubmit)="guardar()">
    <!-- Sección de Espacio -->
    <div class="row mb-4">
      <div class="col-12">
        <h4 class="mb-3">Añadir espacio</h4>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Espacio (MB)</mat-label>
          <input
            matInput
            type="number"
            formControlName="cantidadEspacioMB"
            placeholder="Cantidad de MB"
          />
          <mat-error
            *ngIf="formCuotas.get('cantidadEspacioMB')?.hasError('required')"
          >
            Este campo es requerido
          </mat-error>
          <mat-error
            *ngIf="formCuotas.get('cantidadEspacioMB')?.hasError('min')"
          >
            El valor debe ser mayor o igual a 0
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Precio por MB (€)</mat-label>
          <input
            matInput
            type="number"
            formControlName="precioPorMB"
            placeholder="Precio por MB"
          />
          <mat-error
            *ngIf="formCuotas.get('precioPorMB')?.hasError('required')"
          >
            Este campo es requerido
          </mat-error>
          <mat-error *ngIf="formCuotas.get('precioPorMB')?.hasError('min')">
            El valor debe ser mayor o igual a 0
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Sección de Tiempo -->
    <div class="row mb-4">
      <div class="col-12">
        <h4 class="mb-3">Añadir tiempo</h4>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Horas</mat-label>
          <input
            matInput
            type="number"
            formControlName="cantidadTiempoHoras"
            placeholder="Cantidad de horas"
          />
          <mat-error
            *ngIf="formCuotas.get('cantidadTiempoHoras')?.hasError('required')"
          >
            Este campo es requerido
          </mat-error>
          <mat-error
            *ngIf="formCuotas.get('cantidadTiempoHoras')?.hasError('min')"
          >
            El valor debe ser mayor o igual a 0
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Precio por Hora (€)</mat-label>
          <input
            matInput
            type="number"
            formControlName="precioPorHora"
            placeholder="Precio por hora"
          />
          <mat-error
            *ngIf="formCuotas.get('precioPorHora')?.hasError('required')"
          >
            Este campo es requerido
          </mat-error>
          <mat-error *ngIf="formCuotas.get('precioPorHora')?.hasError('min')">
            El valor debe ser mayor o igual a 0
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Total y Estado de Pago -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="alert alert-info">
          <h5 class="mb-0">
            Total de la Operación sin IVA:
            {{ totalOperacion | currency : "EUR" }}
          </h5>
        </div>
      </div>
      <div class="col-12 mt-3">
        <mat-checkbox formControlName="pagoRecibido" color="primary">
          Pago Recibido (Se ejecutará inmediatamente)
        </mat-checkbox>
      </div>
    </div>

    <!-- Botones de Acción -->
    <div class="row">
      <div class="col-12 text-end">
        <button mat-button type="button" (click)="cerrar()" class="me-2">
          Cancelar
        </button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!formCuotas.valid"
        >
          Guardar
        </button>
      </div>
    </div>
  </form>
</div>
